import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import * as fromSharedStore from 'src/app/shared/store';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private sharedStore: Store<fromSharedStore.State>) {}

  addSuccess = (message: string) => {
    this.sharedStore.dispatch(
      new fromSharedStore.AddToastSuccess({ type: 'success', message })
    );
  };

  addError = (message: string) => {
    this.sharedStore.dispatch(
      new fromSharedStore.AddToastSuccess({ type: 'error', message })
    );
  };

  addNotification = (message: string) => {
    this.sharedStore.dispatch(
      new fromSharedStore.AddToastSuccess({ type: 'notification', message })
    );
  };

  deleteToast = (toast: any) => {
    this.sharedStore.dispatch(new fromSharedStore.DeleteToastSuccess(toast));
  };
}
